import { Link, Match } from '@reach/router'
import React from 'react'
import { Tab as TabWithMatch } from 'webbook-airways'

export function Tab({ to, ...props }) {
  return (
    <Match path={to}>
      {({ match }) => (
        <Link to={to}>
          <TabWithMatch active={match !== null} {...props} />
        </Link>
      )}
    </Match>
  )
}
